import { defineComponent as _defineComponent } from 'vue'
import AppEditorWindow from "@/components/layout/AppEditorWindow.vue"
import PrintableV2 from "@/components/layout/PrintableV2.vue"
import { ConsultantInvoice } from "@/gql"
import { computed, ref } from "vue"
import { useUtilities } from "@/hooks/useUtilities"


export default /*#__PURE__*/_defineComponent({
  __name: 'PrintableInvoice',
  props: {
    invoice: null,
    isOpen: { type: Boolean },
    onClose: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  invoice: ConsultantInvoice
  isOpen: boolean
  onClose: () => void
}



const { formatDate } = useUtilities()

const getTotal = (quantity: number, unitCost: number) => {
  return (quantity * unitCost).toFixed(2)
}

const printable = ref<InstanceType<typeof PrintableV2> | null>(null)

const printInvoice = () => {
  printable.value?.printPage()
}

expose({
  printInvoice,
})

const dueDate = computed(() => {
  return props.invoice.dueAt ?? props.invoice.approvedAt ?? props.invoice.createdAt
})

const issueDate = computed(() => {
  return props.invoice.approvedAt ?? props.invoice.createdAt
})

return { __sfc: true,props, formatDate, getTotal, printable, printInvoice, dueDate, issueDate, AppEditorWindow, PrintableV2 }
}

})